export default "__VITE_ASSET__CEDBs_E8__"